import { render, staticRenderFns } from "./OrderExamples.vue?vue&type=template&id=f935270a&scoped=true"
import script from "./OrderExamples.vue?vue&type=script&lang=js"
export * from "./OrderExamples.vue?vue&type=script&lang=js"
import style0 from "./OrderExamples.vue?vue&type=style&index=0&id=f935270a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f935270a",
  null
  
)

export default component.exports